import React from "react";
import {FormComponent} from "../../components/FormComponent";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {FormGroup} from "../../components/FormComponent/FormGroup";

export class ImportLinguisticValues extends FormComponent {

    render() {
        return (
            <>
                <form className="x-form" action="/linguistic-values/import"
                      encType="multipart/form-data" onSubmit={this.handleSubmit}>

                    <input type="hidden" name="key"/>

                    <div className="row justify-content-center">

                        <div className="col-md-12 col-lg-10 col-xl-8 col-xxl-6">
                            <br/>&nbsp;
                            <h5>{this.dictionary.get['import-linguistic-values']}</h5>

                            <FormGroup.Info>{this.dictionary.get['import-values-help']}</FormGroup.Info>

                            <FormGroup.Input {...{
                                id: 'linguistic-values',
                                label: 'import-linguistic-values',
                                required: true,
                                type: 'file'
                            }}/>

                            <FormSubmit/>
                        </div>
                    </div>
                </form>

            </>
        );
    }
}